<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "专栏审核",
					icon: "",
					router: "/examine/messageexamine",
				},
			],
		};
	},
};
</script>

<style scoped></style>
